import { render, staticRenderFns } from "./RateForLecturerModal.vue?vue&type=template&id=4df6d0e1&scoped=true"
import script from "./RateForLecturerModal.vue?vue&type=script&lang=js"
export * from "./RateForLecturerModal.vue?vue&type=script&lang=js"
import style0 from "./RateForLecturerModal.vue?vue&type=style&index=0&id=4df6d0e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df6d0e1",
  null
  
)

export default component.exports